// Features
export const ESTIMATES = 'estimates';
export const INVOICES = 'invoices';
export const CLIENTS = 'clients';
export const PRICE_BOOK = 'price_book';
export const USERS = 'users';
export const JOBS = 'jobs';
export const JOB_WORKFLOW = 'job_workflow';
export const COMMENTS = 'comments';
export const SUBSCRIPTIONS = 'subscriptions';
export const MEDIA_LIBRARY = 'media_library';
export const REQUESTS = 'requests';
export const TASKS = 'tasks';
export const EMAILS = 'emails';
export const CAMPAIGNS = 'campaigns';
export const TAX_RATES = 'tax_rates';
export const BILLING_SETTINGS = 'billing_settings';
export const CLIENT_COMMUNICATION_SETTINGS = 'client_communication_settings';
export const JOB_SETTINGS = 'job_settings';
export const COMPANY_SETTINGS = 'company_settings';
export const STRIPE_SETTINGS = 'stripe_settings';
export const TAGS = 'tags';
export const ACCOUNT_PLAN = 'account_plan';
export const MESSENGER_SETTINGS = 'messenger_settings';
export const PROFILE = 'profile';
export const REPORTS = 'reports';
export const TAX_REPORT = 'tax_report';
export const PAYMENT_REPORT = 'payment_report';
export const SALES_REPORT = 'sales_report';
export const ACTIVITY_LOG_REPORT = 'activity_log_report';
export const CONVERSATION_STATS_REPORT = 'conversation_stats_report';
export const CONVERSATIONS = 'conversations';

// Actions
export const VIEW = "view";
export const CREATE = "add";
export const EDIT = "edit";
export const DELETE = "delete";
export const EMAIL = "email";
export const SMS = "sms";

// Roles
export const ROLE_ADMIN = "a"
export const ROLE_JOB_PRO = "j"
export const ROLE_VIEWER = "v"